import React from 'react';
import { Helmet } from 'react-helmet';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Clock, Rocket, Star, Zap } from 'lucide-react';
import StaggeredAnimation from '../ui/staggered-animation';
import CountdownTimer from './CountdownTimer';
import FeatureGrid from './FeatureGrid';
import NewsletterSignup from './NewsletterSignup';

const ComingSoon = () => {
  return (
    <>
      <Helmet>
        <title>Coming Soon | Envael - Exciting New Features</title>
        <meta name="description" content="Something amazing is coming to Envael! Stay tuned for revolutionary digital transformation solutions, AI-powered tools, and innovative business growth strategies in Morocco." />
        <meta name="keywords" content="coming soon envael, new features, digital transformation, AI solutions, business growth, morocco technology, innovative tools, upcoming services" />
        <meta property="og:title" content="Coming Soon | Envael - Exciting New Features" />
        <meta property="og:description" content="Something amazing is coming to Envael! Stay tuned for revolutionary digital transformation solutions and AI-powered tools." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://envael.com/coming-soon" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Coming Soon | Envael - Exciting New Features" />
        <meta name="twitter:description" content="Something amazing is coming to Envael! Stay tuned for revolutionary digital transformation solutions." />
        <link rel="canonical" href="https://envael.com/coming-soon" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/20 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full space-y-8">
        {/* Hero Section */}
        <StaggeredAnimation delay={100} animation="fadeUp">
          <div className="text-center space-y-4">
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl"></div>
                <div className="relative bg-primary/10 border border-primary/20 rounded-full p-6">
                  <img 
                    src="/Logos/Asset 1front.svg" 
                    alt="Envael Logo" 
                    className="h-16 w-16 text-primary animate-pulse"
                    style={{ filter: 'brightness(0) saturate(100%) invert(67%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(102%) contrast(87%)' }}
                  />
                </div>
              </div>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-primary via-primary/80 to-primary/60 bg-clip-text text-transparent">
              EnvaelSources
            </h1>
            
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              The future of business management is coming soon. Get ready for a revolutionary platform that will transform how you run your company.
            </p>
          </div>
        </StaggeredAnimation>

        {/* Countdown Timer */}
        <StaggeredAnimation delay={200} animation="fadeUp">
          <Card className="border-primary/20 bg-gradient-to-r from-primary/5 to-primary/10">
            <CardHeader className="text-center">
              <CardTitle className="flex items-center justify-center space-x-2">
                <Clock className="h-5 w-5 text-primary" />
                <span>Launch Countdown</span>
              </CardTitle>
              <CardDescription>
                We're putting the finishing touches on something amazing
              </CardDescription>
            </CardHeader>
            <CardContent>
              <CountdownTimer />
            </CardContent>
          </Card>
        </StaggeredAnimation>

        {/* Features Grid */}
        <StaggeredAnimation delay={300} animation="fadeUp">
          <FeatureGrid />
        </StaggeredAnimation>

        {/* Newsletter Signup */}
        <StaggeredAnimation delay={400} animation="fadeUp">
          <NewsletterSignup />
        </StaggeredAnimation>

        {/* Footer */}
        <StaggeredAnimation delay={500} animation="fadeUp">
          <div className="text-center space-y-4 pt-8 border-t border-border/50">
            <div className="flex justify-center mb-4">
              <img 
                src="/Logos/Asset 1front.svg" 
                alt="Envael Logo" 
                className="h-8 w-8"
                style={{ filter: 'brightness(0) saturate(100%) invert(67%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(102%) contrast(87%)' }}
              />
            </div>
            <div className="flex justify-center space-x-6">
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Star className="h-4 w-4 text-yellow-500" />
                <span>Revolutionary Features</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Zap className="h-4 w-4 text-blue-500" />
                <span>Lightning Fast</span>
              </div>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Rocket className="h-4 w-4 text-primary" />
                <span>Future Ready</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              © 2024 EnvaelSources. All rights reserved. Built with passion and precision.
            </p>
          </div>
        </StaggeredAnimation>
      </div>
      </div>
    </>
  );
};

export default ComingSoon;
